{
	"title": "Progress",
	"subtitle": "Learning analytics and statistics",
	"overview": {
		"title": "Overview",
		"thisWeek": "This week",
		"thisMonth": "This month",
		"allTime": "All time"
	},
	"stats": {
		"materialsStudied": "Materials studied",
		"cardsReviewed": "Cards reviewed",
		"quizzesCompleted": "Quizzes completed",
		"minutesStudied": "Minutes studied",
		"averageScore": "Average score"
	},
	"range": {
		"label": "Range",
		"week": "Week",
		"month": "Month",
		"year": "Year"
	},
	"kpi": {
		"streakLabel": "Streak",
		"streakValue": "{days, plural, one {# day} other {# days}}",
		"streakValueLabel": "{days, plural, one {day in a row} other {days in a row}}",
		"streakHint": "To record: {days, plural, one {# day} other {# days}}",
		"streakHintAtRecord": "Personal record!",
		"masteryLabel": "Mastery",
		"masteryHint": "mastered this {range}",
		"minutesLabel": "Time",
		"minutesValue": "{hours}h {minutes}m",
		"minutesShort": "{minutes}m",
		"minutesHint": "studied this {range}",
		"activitiesLabel": "Activities",
		"activitiesHint": "activities completed",
		"moreDetails": "Details",
		"trendUp": "▲ {value}",
		"trendDown": "▼ {value}",
		"trendNone": "—"
	},
	"charts": {
		"mastery": "Mastery over time",
		"studyTime": "Time per day",
		"timeSpent": "Study minutes",
		"srsReviewed": "Reviewed cards",
		"minutes": "min",
		"retention": "Retention",
		"weakAreas": "Weak areas",
		"emptyHint": "Data appears after your first sessions"
	},
	"heatmap": {
		"title": "Activity over {days} days",
		"cardTitle": "Your rhythm",
		"activeDays": "{active} of {total} active days",
		"cellActive": "{date} — {minutes, plural, one {# minute} other {# minutes}}",
		"cellEmpty": "{date} — no study",
		"empty": "Your rhythm appears after your first sessions",
		"less": "Less",
		"more": "More"
	},
	"mastery": {
		"empty": "No topic data yet"
	},
	"noExam": "No upcoming exam",
	"modules": {
		"title": "By material",
		"all": "All materials",
		"untitled": "Untitled",
		"columns": {
			"material": "Material",
			"cards": "Activities",
			"mastery": "Mastery"
		},
		"empty": "No materials yet",
		"emptyHint": "Upload your first material — stats appear automatically",
		"mobileMeta": "{cardsDone}/{cardsTotal} activities",
		"sortBy": "Sort by",
		"sort": {
			"mastery": "Mastery",
			"progress": "Progress",
			"recent": "Recent"
		}
	},
	"feed": {
		"title": "Activity",
		"empty": "No activity",
		"emptyHint": "Your recent study sessions will show up here",
		"showMore": "Show more",
		"durationMin": "{minutes} min",
		"kind": {
			"material.uploaded": "Uploaded material",
			"material.processed": "Notes ready",
			"note.generated": "Note generated",
			"flashcard-set.generated": "Flashcard set created",
			"quiz.completed": "Quiz completed",
			"tutor.session": "Tutor session",
			"audio.generated": "Audio ready",
			"essay.graded": "Essay graded",
			"study-plan.completed-activity": "Plan activity",
			"recording.completed": "Lecture recorded"
		}
	},
	"empty": {
		"title": "Progress will appear after your first session",
		"body": "Start by uploading a material or reviewing cards",
		"upload": "Upload material",
		"recommendations": "See recommendations"
	},
	"tabs": {
		"feed": "Activity",
		"recommendations": "Recommendations"
	},
	"actions": {
		"export": "Export",
		"exportCsv": "CSV",
		"exportPdf": "PDF",
		"exportJson": "JSON"
	},
	"error": {
		"title": "Failed to load",
		"retry": "Retry"
	},
	"streaks": {
		"title": "Streak",
		"current": "{days, plural, one {# day} other {# days}} in a row",
		"longest": "Longest: {days, plural, one {# day} other {# days}}",
		"dailyGoal": "Daily goal",
		"goalReached": "Goal reached!",
		"minutesLeft": "{minutes} min to go",
		"frozen": "Streak frozen",
		"freezesLeft": "Freezes left: {count}"
	},
	"recommendations": {
		"title": "Review today",
		"subtitle": "Adaptive recommendations",
		"empty": "No recommendations",
		"refresh": "Refresh"
	},
	"intro": {
		"title": "Where these numbers come from",
		"body": "Everything is counted from what you actually do: repetitions, tests, minutes. Nothing has to be ticked off by hand.",
		"bullets": [
			"Mastery comes from answers, not from “read” checkmarks",
			"The streak is held by a daily goal in minutes",
			"The heat map shows the rhythm of your sessions"
		]
	}
}
